import React, { useState } from 'react';
import PageDetails from '../PageDetails/PageDetails'
import TabFirst from '../TabFirst/TabFirst'


const tabsList = [
  {tabId: 'SOCIAL', displayText: 'Inspection'},
  {tabId: 'GAMES', displayText: 'Machine'},
  {tabId: 'NEWS', displayText: 'Workspace & Quality'},
  {tabId: 'FOOD', displayText: 'Inspection Tool'},
]

const appsList = [
  {
    appId: 0,
    appName: 'Facebook',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/social-facebook.png',
    category: 'SOCIAL',
    categoryDetails:[
      {
        InspectionItem: "Filter Condition",
        Description:"Check for any tears, holes, or damage to the filter material.",
        ActionRequired: "Replace if damaged or excessively dirty.",
      },
      {
        InspectionItem: "Contaminant Accumulation",
        Description:"Assess the level of contaminants (such as water, sediment, or debris) accumulated in the filter..",
        ActionRequired: "Clean or replace if heavily soiled.",
      },
      {
        InspectionItem: "Filter Housing",
        Description:"Inspect the housing for any cracks, leaks, or misalignment.",
        ActionRequired: "Repair or replace if necessary.",
      },
      {
        InspectionItem: "Seal Integrity",
        Description:"Ensure that the seal between the filter and housing is intact and secure.",
        ActionRequired: "Replace seal if damaged or leaking.",
      },
      {
        InspectionItem: "Flow Restriction",
        Description:"Measure the flow rate through the filter using appropriate tools",
        ActionRequired: "Clean or replace if flow is restricted.",
      },
      {
        InspectionItem: "Installation",
        Description:"Verify proper installation of the filter according to manufacturer's instructions.",
        ActionRequired: "Reinstall correctly if necessary.",
      },
      {
        InspectionItem: "Filter Compatibility",
        Description:"Confirm that the filter is compatible with the specific diesel engine model and fuel type.",
        ActionRequired: "Replace with suitable filter if necessary.",
      },
      {
        InspectionItem: "Maintenance History",
        Description:"Review past maintenance records to determine when the filter was last inspected or replaced.",
        ActionRequired: "Schedule replacement or cleaning accordingly.",
      },

      // {
      //   InspectionItem: "Maintenance History",
      //   Description:"Review previous maintenance records to determine when the filter was last inspected or replaced.",
      //   ActionRequired: "Schedule replacement or cleaning accordingly.",
      // }
    ]
  },
  
  {
    appId: 2,
    appName: 'Subway Surfers',
    imageUrl:
      'https://www.kanwalenterprises.com/public/images/products/img-automotive-filter-manufacturing-machines.jpg',
    category: 'GAMES',
    
  },

  
  {
    appId: 4,
    appName: 'Inshorts',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/news-inshorts.png',
    category: 'NEWS',
    heading:"DieselFilter",
    content:"GIFCO, based in Bengaluru, is highly praised by clients as top-tier Diesel Filter manufacturers, suppliers, and exporters. We're dedicated to meeting market standards responsibly and responsively. With 26 years of industry experience, clients trust the quality of our products. Our Diesel Filter comes in various customizations to suit your budget and industry needs. Equipped with advanced technology, our Diesel Filter ensures reliable performance even in tough conditions. As reliable Diesel Filter  manufacturers, suppliers, and exporters, we offer our complete range at competitive industry prices. For more information on this machine or any of our products, don't hesitate to reach out with inquiries.",
    features : [
      'Brilliant performance',
      'Longevity',
      'Dependable',
      'Easy installation',
      'Smooth operation',
      'Reasonable price',
    ],

    specifications : [
      'The specifications are  not fixed for the product and  we provide what our clients ask for.',
    ],

  },
  
  {
    appId: 5,
    appName: 'Zomato',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/food-zomato.png',
    category: 'FOOD',
    imageUrl:""
  },
  
]

// Write your code here
const DiselFilterPageStore = () => {
  const [activeTabId, setActiveTabId] = useState(tabsList[0].tabId);
  const [searchInput, setSearchInput] = useState('');
  

  const getFilteredProjects = () => {
    const filterdata = appsList.filter(
      (eachdetails) => eachdetails.category === activeTabId
    );
    return filterdata;
  };

  const onchangestatus = (tabId) => {
    setActiveTabId(tabId);
  };

  const getinputdetails = (event) => {
    setSearchInput(event.target.value);
  };

  const fliterdataproject = getFilteredProjects();
  const searchresult = fliterdataproject.filter((eachfilterdata) =>
    eachfilterdata.appName.includes(searchInput)
  );

  return (
    <div className="appcontainer">
      <div className="cardcontainer">
        <div className="upcontainer">
          {/* <div className="search-input-container">
            <input
              type="search"
              className="search-input"
              placeholder="Search"
              onChange={getinputdetails}
            />
            <img
              src="https://assets.ccbp.in/frontend/react-js/app-store/app-store-search-img.png "
              alt="search icon"
              className="search_icon"
            />
          </div> */}
        </div>
        <ul className="tabitemcontainer">
          {tabsList.map((each) => (
            <TabFirst
              tabname={each}
              key={each.tabId}
              onchangestatus={onchangestatus}
              isActive={activeTabId === each.tabId}
            />
          ))}
        </ul>
        <ul className="appcontainer">
          {searchresult.map((each) => (
            <PageDetails Appitem={each} key={each.appId} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DiselFilterPageStore;
